var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"mobile-navigator-map",on:{"click":_vm.onClick}},[_c('app-icon',{attrs:{"icon":"map","is-active":_vm.isActive}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }